import { SPECIE_NAMES_LIST } from 'src/types/SpecieName';

export const DISTANCE_OPTIONS = [
  { label: 'até 50km', value: '50' },
  { label: 'até 100km', value: '100' },
  { label: 'até 200km', value: '200' },
  { label: 'até 250km', value: '250' },
  { label: '+ de 300km', value: '300' },
];

export const CONTACT = {
  name: 'João de  Jesus',
  address: 'Zona Rural, Nova Xavantina - TO',
  distance: '37,3',
  lat: -28.84985,
  lng: -49.324521,
};

export const DEFAULT_PROPERTY_CARD = {
  id: '1',
  name: 'Fazenda Santa Amélia',
  address: 'Zona Rural, Nova Xavantina - TO',
  distance: '57,6km',
  lat: -28.84985,
  lng: -49.324521,
  species: SPECIE_NAMES_LIST.slice(0, 2),
  statusList: ['Em momento de corte', 'Corte futuro'],
  onShowProfile: () => {
    return null;
  },
  onCall: () => {
    return null;
  },
  onSave: undefined,
  onDelete: undefined,
};
